import React, { useState } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Logo from "../../../../public/images/logo-new.svg";
import {
  BasicInfoContainer,
  ImageContainer,
  Title,
  TitleContainer,
  StyledForm,
  FieldsContainer,
  CustomSubmitButton,
  Subtitle,
} from "./BasicInfo.styles";
import { InfoMessage, TextField } from "../..";
import { emailValidation } from "../../../utils/regex";
import { forgotPasswordAdmin } from "../../../services/AuthenticationService";
import { LoginInterface } from "../../../models/Login";

interface BasicInfoProps extends WithRouterProps {
  onNextButtonClick: Function;
}

const BasicInfo: React.FC<BasicInfoProps> = ({ onNextButtonClick }) => {
  const [email, setEmail] = useState<string>("");

  const [emailError, setEmailError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [loading, setLoading] = useState<boolean>(false);

  const isSubmitButtonDisabled = () => {
    return !email;
  };

  const handleEmailChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setEmail(event.target.value);
    setEmailError(false);
  };

  const handleEnterSubmit = ((event: React.FormEvent) => {
    event.preventDefault();
    if (!isSubmitButtonDisabled) {
      handleResetPassword()
    }
  });

  const handleResetPassword = () => {
    if (!emailValidation(email)) {
        setEmailError(true);
        setErrorMessage("Oops! Your email appears to be in the wrong format.");
        return;
    }
    setEmailError(false);
    setLoading(true);

    let forgotPasswordData: LoginInterface = { 
      email: email
    };

    forgotPasswordAdmin(forgotPasswordData).then((res) => {
       if (res.status === 400) {
        setEmailError(true);
        setErrorMessage(res.errors?.message?.[0]);
      } else {
        onNextButtonClick();
      }
      setLoading(false);
    })
  };

  return (
    <BasicInfoContainer>
      <ImageContainer>
        <Logo />
      </ImageContainer>
      <TitleContainer>
        <Title>Reset Your Password</Title>
        <Subtitle>
          Enter your email below and we’ll send you a reset link
        </Subtitle>
      </TitleContainer>
      <StyledForm onSubmit={handleEnterSubmit}>
        <FieldsContainer>
          <TextField
            data-cy="register-email"
            size="lg"
            autoFocus
            fullWidth
            error={emailError}
            value={email}
            onChange={handleEmailChange}
            placeholder="Your Email"
          />
          {emailError && (
            <InfoMessage
              data-cy="register-error"
              variant="error"
              hasBackground={true}
              message={errorMessage}
            />
          )}
        </FieldsContainer>
        <CustomSubmitButton
          data-cy="register-basic-info-submit"
          onClick={handleResetPassword}
          disabled={isSubmitButtonDisabled()}
          disabledStateStyling="lowOpacity"
          loading={loading}
          type="submit"
        >
          Send Reset Email
        </CustomSubmitButton>
      </StyledForm>
    </BasicInfoContainer>
  );
};

BasicInfo.displayName = "BasicInfo";

const ComponentWithRouter = withRouter(BasicInfo);

export { ComponentWithRouter as BasicInfo };
